var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.88,36C107.38-12,37.68-12,1.12,36A5.52,5.52,0,0,0,2,43.54a5,5,0,0,0,7.25-.87C41.59.14,103.36.08,135.79,42.67a5,5,0,0,0,7.25.87A5.52,5.52,0,0,0,143.88,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.74,55.42A5.53,5.53,0,0,0,25.58,63a5,5,0,0,0,7.26-.87c20.29-26.65,59-26.7,79.32,0a5,5,0,0,0,7.26.87,5.53,5.53,0,0,0,.84-7.55C95.82,23.35,49.21,23.3,24.74,55.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.36,74.85a5.53,5.53,0,0,0,.84,7.55,5,5,0,0,0,7.26-.88,20,20,0,0,1,32.08,0,5,5,0,0,0,7.26.88,5.53,5.53,0,0,0,.84-7.55A30,30,0,0,0,48.36,74.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 72.5,
    cy: 106.46,
    rx: 13.01,
    ry: 13.54
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.e30f173c.svg";
export { ForwardRef as ReactComponent };